import React, { useState } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import BuildAithAiCard from "./Components/CreateTrivia/BuildWithAicard";
import CreateTriviaPopup from "./Components/CreateTrivia/CreateTriviaPopup";
import { BUILT_WITH_AI_PROMPTS, BUILT_WITH_AI_PROMPTS_STANDARD } from "./data";

export default function SurveySamplesPage({ open, onClose, ...props }) {
  const [createPopupOpen, setCreatePopupOpen] = useState(false);
  const [preSelectedPopupData, setPreselectedPopupData] = useState({
    selectedPrompt: "",
  });

  const closeCreatePopup = () => {
    setCreatePopupOpen(false);
 
  };
  return (
    <div>
      {createPopupOpen &&
          preSelectedPopupData &&
          preSelectedPopupData.selectedPrompt ? (
            <CreateTriviaPopup
              open={createPopupOpen}
              onClose={closeCreatePopup}
              onAddSuccess={() => {
                props.history.push("list");
              }}
              preSelectedData={preSelectedPopupData}
              generateFromLibrary={false}
              user={props.user}
              autoSelectedTrivvyType="AI"
              onlyAllowCustomTextPrompt={true}
              history={props.history}
            />
          ) : (
            ""
          )}
       <Modal isOpen={open} className="trivvy-samples-modal-container">
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Survey Sample Prompts
      </ModalHeader>

      <ModalBody className="p-3">
        <div className="my-2">
          
          <Row className="trivvy_samples_modal_row_container">
            {BUILT_WITH_AI_PROMPTS_STANDARD.map((prompt) => {
              return (
                <Col md={4} xs={12} className="mt-3">
                  <BuildAithAiCard
                    title={prompt.title}
                    description={prompt.description}
                    handleSelect={() => {
                      setCreatePopupOpen(true);
                      setPreselectedPopupData({
                        selectedPrompt: prompt.description,
                      });
                      onClose()
                    }}
                  />
                </Col>
              );
            })}
          </Row>
        </div>
      </ModalBody>
    </Modal>
    </div>
   
  );
}
